import { CUSTOM_ELEMENTS_SCHEMA, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: 'hartfelt-header',
  templateUrl: './hartfelt-header.html',
  styleUrls: ['./hartfelt-header.scss'],
})
export class HartfeltHeaderComponent {
  @Input() icon: string = 'https://cdn.hartfelt.com/images/Hartfelt-logo.png';
  @Input() dynamicPhoneNumber: string = `<a href="tel:800-955-1518">800-955-1518</a>`;
  @Input() displayPhone: boolean = false;
  @Input() hidePhoneOnMobile: boolean = false;
  @Input() phoneIcon: string = '';
  @Input() cartQuantity: number | undefined;
  @Input() braintreeDefaultCountry: string = 'United States';

  isCheckout: boolean = false;

  isMobile: boolean = false;

  @Input() menu: Array<string> = [];
  @Input() displayMenu: boolean = false;
  @Input() hideMenuOnMobile: boolean = false;

  //Set to TRUE if set on order-from page
  @Input() showOnOrderForm: boolean = false;
  @Input() headerText: string = '';

  //Set to TRUE is set on order-success page
  @Input() showOnOrderSuccess: boolean = false;
  @Input() showLine: boolean = false;

  //Set to TRUE if placed on upsell page
  @Input() showOnUpsell: boolean = false;

  //Provide external method to navigate to next page over funnel
  @Output() nextPageEvent = new EventEmitter();

  window: any = window;
  isToggledOff: boolean = true;

  constructor(
  ) {

  }

  nextPage(page: any) {
    this.nextPageEvent.emit(page);
  }

}